<ng-container [formGroup]="formGroup">
  <div class="field-checkbox" style="display: flex">
    <p-checkbox
      [formControl]="$any(formGroup).controls[fieldName]"
      [binary]="true"
      [class]="validation()"
      inputId="id-{{ fieldName }}"
    ></p-checkbox>
    <label for="id-{{ fieldName }}" style="margin-left: 12px">
      <ng-content></ng-content>
    </label>
  </div>
  <app-error-message
    [control]="control"
    [field]="fieldName"
  ></app-error-message>
</ng-container>
